import { useState } from 'react';

const testimonials = [
  {
    name: 'Marcus J.',
    role: 'Streetwear Enthusiast, UK',
    quote: 'This pandabuyspreadsheet completely changed how I shop. I have found so many incredible streetwear pieces that I would never have discovered on my own. The weekly updates keep everything fresh and relevant.',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20of%20a%20young%20man%20on%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20editorial%20portrait%20photography%2C%20warm%20sepia%20tones%2C%20clean%20composition%2C%20simple%20and%20elegant%20aesthetic&width=200&height=200&seq=avatar-testimonial-01&orientation=squarish'
  },
  {
    name: 'Sophie L.',
    role: 'Fashion Blogger, USA',
    quote: 'I have tried dozens of fashion spreadsheets and this pandabuyspreadsheet is by far the most organized and well-curated. The quality ratings actually mean something and save me so much time.',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20of%20a%20young%20woman%20on%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20editorial%20portrait%20photography%2C%20warm%20sepia%20tones%2C%20clean%20composition%2C%20simple%20and%20elegant%20aesthetic&width=200&height=200&seq=avatar-testimonial-02&orientation=squarish'
  },
  {
    name: 'Alex T.',
    role: 'Sneaker Collector, Germany',
    quote: 'The sneaker section of this pandabuyspreadsheet is unmatched. Budget finds that actually look premium — exactly what I was searching for. The structured layout makes browsing effortless.',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20of%20a%20young%20man%20on%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20editorial%20portrait%20photography%2C%20warm%20sepia%20tones%2C%20clean%20composition%2C%20simple%20and%20elegant%20aesthetic&width=200&height=200&seq=avatar-testimonial-03&orientation=squarish'
  },
  {
    name: 'Emily R.',
    role: 'Budget Shopper, Canada',
    quote: 'Finally a pandabuyspreadsheet that actually delivers. I have saved hundreds using the budget fashion section. The community-tested badge gives me confidence before buying anything.',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20of%20a%20young%20woman%20on%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20editorial%20portrait%20photography%2C%20warm%20sepia%20tones%2C%20clean%20composition%2C%20simple%20and%20elegant%20aesthetic&width=200&height=200&seq=avatar-testimonial-04&orientation=squarish'
  },
];

export default function Testimonials() {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => (c === 0 ? testimonials.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === testimonials.length - 1 ? 0 : c + 1));

  const t = testimonials[current];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 text-center mb-12">
            (What Shoppers Say)
          </h2>

          <div className="bg-background-50 rounded-2xl p-8 md:p-12 border border-background-200/50">
            <div className="flex items-center gap-2 mb-8">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-foreground-900 text-white rounded-full text-xs font-semibold">
                <i className="ri-star-fill text-accent-400 text-xs"></i>
                4.9
              </span>
            </div>

            <blockquote className="font-heading text-xl md:text-2xl text-foreground-800 leading-relaxed italic mb-8">
              &ldquo;{t.quote}&rdquo;
            </blockquote>

            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-12 h-12 rounded-full object-cover border-2 border-white"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>

              <div className="flex items-center gap-2">
                <button
                  onClick={prev}
                  className="w-10 h-10 flex items-center justify-center rounded-lg border border-foreground-200 text-foreground-600 hover:bg-foreground-100 transition-colors cursor-pointer"
                  aria-label="Previous testimonial"
                >
                  <i className="ri-arrow-left-line"></i>
                </button>
                <button
                  onClick={next}
                  className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-900 text-white hover:bg-foreground-800 transition-colors cursor-pointer"
                  aria-label="Next testimonial"
                >
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}